/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Batch_Subtitle_Export_Select_Folder_TitleInputs */

const en_batch_subtitle_export_select_folder_title = /** @type {(inputs: Batch_Subtitle_Export_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtitle Batch Export - Select Folder`)
};

const fr_batch_subtitle_export_select_folder_title = /** @type {(inputs: Batch_Subtitle_Export_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportation par lot de sous-titres - Sélectionner un dossier`)
};

const de_batch_subtitle_export_select_folder_title = /** @type {(inputs: Batch_Subtitle_Export_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertitel-Stapelexport – Ordner auswählen`)
};

const it_batch_subtitle_export_select_folder_title = /** @type {(inputs: Batch_Subtitle_Export_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportazione batch sottotitoli - Seleziona cartella`)
};

const ru_batch_subtitle_export_select_folder_title = /** @type {(inputs: Batch_Subtitle_Export_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пакетный экспорт субтитров - Выберите папку`)
};

const es_batch_subtitle_export_select_folder_title = /** @type {(inputs: Batch_Subtitle_Export_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportación por lotes de subtítulos: Seleccionar carpeta`)
};

const zh_cn2_batch_subtitle_export_select_folder_title = /** @type {(inputs: Batch_Subtitle_Export_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕批量导出 - 选择文件夹`)
};

const ja_batch_subtitle_export_select_folder_title = /** @type {(inputs: Batch_Subtitle_Export_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕一括エクスポート - フォルダの選択`)
};

const hi_batch_subtitle_export_select_folder_title = /** @type {(inputs: Batch_Subtitle_Export_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपशीर्षक बैच निर्यात - फ़ोल्डर चुनें`)
};

const pt_pt2_batch_subtitle_export_select_folder_title = /** @type {(inputs: Batch_Subtitle_Export_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportação em lote de legendas - Selecionar pasta`)
};

/**
* | output |
* | --- |
* | "Subtitle Batch Export - Select Folder" |
*
* @param {Batch_Subtitle_Export_Select_Folder_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const batch_subtitle_export_select_folder_title = /** @type {((inputs?: Batch_Subtitle_Export_Select_Folder_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Batch_Subtitle_Export_Select_Folder_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_batch_subtitle_export_select_folder_title(inputs)
	if (locale === "de") return de_batch_subtitle_export_select_folder_title(inputs)
	if (locale === "it") return it_batch_subtitle_export_select_folder_title(inputs)
	if (locale === "ru") return ru_batch_subtitle_export_select_folder_title(inputs)
	if (locale === "es") return es_batch_subtitle_export_select_folder_title(inputs)
	if (locale === "zh-CN") return zh_cn2_batch_subtitle_export_select_folder_title(inputs)
	if (locale === "ja") return ja_batch_subtitle_export_select_folder_title(inputs)
	if (locale === "hi") return hi_batch_subtitle_export_select_folder_title(inputs)
	if (locale === "pt-PT") return pt_pt2_batch_subtitle_export_select_folder_title(inputs)
	return en_batch_subtitle_export_select_folder_title(inputs)
});